export default "__VITE_ASSET__Bqkd1G1D__"